import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { StockLevelMonitoringEventEntityLinkModel } from '../../../../../../models/aggregates/erp/stock/stock-level-monitoring-event-entity-link.model';
import { BaseApiTemplateService } from '../../shared';


@Injectable({ providedIn: 'root' })
export class StockLevelMonitoringEventEntityLinkService extends BaseApiTemplateService<StockLevelMonitoringEventEntityLinkModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-event-entity-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-event-entity-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-event-entity-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = theHttp;
  }

}
